<template>
<!-- 注意：此页面为老系统直接复制过来：保持原有功能 -->
  <div class="print-page">
    <div class="qrcode" v-for="(item,index) in qrAddressList" :key="index">
      <p class="text">
        <span>“知到-教师版”APP扫码</span>
        <span>开启教室设备</span>
      </p>
      <img :src="item.qrAddress" width="170">
      <p>{{item.classroomName}}</p>
    </div>
  </div>
</template>
<script>

export default {
  data(){
    return {
      qrAddressList: []
    }
  },
  created(){
    this.queryAllClassroomQr()
  },
  methods:{
    queryAllClassroomQr(){
      let params = this.$route.params
      console.log('parmas', params);
      this.$http.queryAllClassroomQr(params).then(res=>{
        console.log('queryAllClassroomQr---',res)
        this.qrAddressList = res.rt
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.print-page{
  display: flex;
  flex-wrap: wrap;
  .qrcode {
    width: 249px;
    height: 340px;
    margin-right: 30px;
    margin-bottom: 30px;
    background: #3DB166;
    border-radius: 6px;
    color: #fff;
    text-align: center;
    img{
      margin: 20px 0 25px;
    }
    .text{
      padding-top: 30px;
      font-size: 18px;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>